/**
 * Banner carousel (width) accents for sections/banner-carousel-width.liquid.
 *
 * Derives each card's accent from its banner artwork via the shared
 * dominant-color sampler, so the solid panel always matches the image.
 * The saved accent_color paints first and stays as the fallback.
 *
 * Initializes every `[data-ix-bcw]` section on load and again on
 * `shopify:section:load` for theme-editor re-renders.
 */
import { sampleDominantColor } from '@theme/ix-accent';

function initCarousel(root) {
  if (!root || root.dataset.ixAccentInit === '1') return;
  root.dataset.ixAccentInit = '1';

  root.querySelectorAll('.ix-banner-card').forEach((card) => {
    if (card.getAttribute('data-auto-accent') === '0') return;
    const art = card.querySelector('.ix-banner-card__image');
    if (!art || art.tagName !== 'IMG') return;

    const derive = () => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const color = sampleDominantColor(img, 32);
        if (!color) return; // tainted canvas or too little signal: keep the fallback accent
        let r = color.r;
        let g = color.g;
        let b = color.b;
        // Sephora-style solid panel: keep the dominant color as-is,
        // only darkening very light tones so the panel reads as a
        // color block, then pick white/dark text for contrast
        // (unless the block sets its own text color).
        let L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (L > 175) {
          const k = 175 / L;
          r *= k;
          g *= k;
          b *= k;
          L = 175;
        }
        card.style.setProperty('--banner-accent', 'rgb(' + Math.round(r) + ' ' + Math.round(g) + ' ' + Math.round(b) + ')');
        if (!card.style.getPropertyValue('--card-color')) {
          card.style.setProperty('--card-color', L < 160 ? '#ffffff' : '#1a1a1a');
        }
      };
      img.src = art.currentSrc || art.src;
    };

    if (art.complete) derive();
    else art.addEventListener('load', derive, { once: true });
  });
}

function initAll(scope) {
  scope.querySelectorAll('[data-ix-bcw]').forEach(initCarousel);
}

initAll(document);
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
